<template>
	<div>
		<!--工具条-->
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input v-model="inputMac" placeholder="请输入DID" prefix-icon="el-icon-search" size="small"></el-input>
				</el-form-item>
				<el-form-item>
				<el-date-picker v-model="Time" size="small" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
    			</el-form-item>
				<el-form-item>
					<!--<el-button type="primary" size="small" @click="Find">查询</el-button>-->
					<el-button type="primary" size="small" @click="BeforeFind" icon="el-icon-search">搜索</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<el-table :data="List" border v-loading="listloading" style="width: 99.9%;" :max-height="maxHeight">
		    <el-table-column fixed label="设备DID" prop="did" width="150"></el-table-column>
<!--			<el-table-column label="设备版本" prop="d1" width="80" :formatter="d1Format"></el-table-column>-->
			<el-table-column label="软件版本" prop="d2" width="80" :formatter="d2Format"></el-table-column>
<!--			<el-table-column label="站立" prop="d3" width="70">-->
<!--				<template slot-scope="scope">-->
<!--					<span v-if="scope.row.d3 == 0">未站立</span>-->
<!--					<span v-if="scope.row.d3 == 1">站立</span>-->
<!--					<span v-if="scope.row.d3 == 33">久站</span>-->
<!--					<span v-if="scope.row.d3 == 34">久站</span>-->
<!--				</template>-->
<!--			</el-table-column>-->
			<el-table-column label="发送时间" prop="d4" width="160" :formatter="dateFormat"></el-table-column>
			<el-table-column label="GPS信号" prop="d5" width="120">
				<template slot-scope="scope">
					<span v-if="scope.row.d5 == '[,]' || scope.row.d5 == '[0,0]'">室内</span>
					<span v-if="scope.row.d5 != '[,]' && scope.row.d5 != '[0,0]'">
						{{scope.row.d5}}
<!--						<el-button type="primary" size="mini" icon="el-icon-search" style="padding: 2px;" @click="showmap(scope.$index,scope.row)"></el-button>-->
					</span>
				</template>
			</el-table-column>
			<el-table-column label="基站信号" prop="d6" width="110"></el-table-column>
			<el-table-column label="故障点个数" prop="d7" width="70"></el-table-column>
			<el-table-column label="电池信息">
				<el-table-column label="充电状态">
					<template slot-scope="scope">
						<span v-if="scope.row.d8">
							{{(scope.row.d8.substring(1,scope.row.d8.length - 1)).split(",")[0] == 0 ? "未充电" : "充电中"}}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="在线状态">
					<template slot-scope="scope">
						<span v-if="scope.row.d8">
							{{(scope.row.d8.substring(1,scope.row.d8.length - 1)).split(",")[1] == 0 ? "在线" : "断线"}}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="报警信息">
					<template slot-scope="scope">
						<span v-if="scope.row.d8">
							{{(scope.row.d8.substring(1,scope.row.d8.length - 1)).split(",")[2] == 0 ? "无" : "故障" }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="电量">
					<template slot-scope="scope">
						<span v-if="scope.row.d8">
							{{(scope.row.d8.substring(1,scope.row.d8.length - 1)).split(",")[3]}}%
						</span>
					</template>
				</el-table-column>
			</el-table-column>
			<!--<el-table-column label="state1" prop="d9" width="120"></el-table-column>-->
			<el-table-column v-for="(item,index) in statelist" :label='item.cn' :key="item.index">
		    	<template slot-scope="scope">
		    		{{scope.row.d9[index]}}
			    </template>
		    </el-table-column>
			<!--<el-table-column label="state2" prop="d10" width="120"></el-table-column>-->
			<el-table-column fixed="right" label="时间" prop="time" width="180" :formatter="dateFormat"></el-table-column>
  		</el-table>
		
		<!--工具条-->
  		<el-col :span="24" class="toolbar downtool">
			<el-pagination layout="prev, pager, next,jumper" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		
		<!--电池情况-->
		<el-dialog title="电池详情" :visible.sync="Bateryvisable" width="35%">
			<el-row>
				<el-col :span="12">
			  		<div>电池电压：{{dianya}}V</div>
			 	</el-col>
			 	<el-col :span="12">
			  		<div>电池电流：{{dianliu}}A</div>
			 	</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
			  		<div>剩余电量：{{dianliang}}%</div>
			 	</el-col>
			 	<el-col :span="12">
			  		<div>电池温度：{{wendu}}°</div>
			 	</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
			  		<div>充电状态：<span v-if="this.chongdian == 1">充电中</span><span v-if="this.chongdian == 0">未充电</span></div>
			 	</el-col>
			 	<el-col :span="12">
			  		<div>电池节数：{{chuan}}串</div>
			 	</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
			  		<div>充电警报：</div>
				</el-col>
			</el-row>
			<el-row>
			  	<el-col :span="13" :offset="2"><div>电压报警、压差保护、断线保护：</div></el-col>
			  	<el-col :span="4"><div><span v-if="this.a == 0">正常</span><span v-if="this.a == 1" style="color: red;">错误</span></div></el-col>
			</el-row>
			<el-row>
				<el-col :span="13" :offset="2"><div>充电fet损坏报警：</div></el-col>
			  	<el-col :span="4"><div><span v-if="this.b == 0">正常</span><span v-if="this.b == 1" style="color: red;">错误</span></div></el-col>
			</el-row>	
			<el-row>
			  	<el-col :span="13" :offset="2"><div>SD：</div></el-col>
			  	<el-col :span="4"><div><span v-if="this.c == 0">正常</span><span v-if="this.c == 1" style="color: red;">错误</span></div></el-col>
			</el-row>
			<el-row>
				<el-col :span="13" :offset="2"><div>ML5238通信：</div></el-col>
			  	<el-col :span="4"><div><span v-if="this.d == 0">正常</span><span v-if="this.d == 1" style="color: red;">错误</span></div></el-col>
			</el-row>
			<el-row>
				<el-col :span="13" :offset="2"><div>E2PROM：</div></el-col>
			  	<el-col :span="4"><div><span v-if="this.e == 0">正常</span><span v-if="this.e == 1" style="color: red;">错误</span></div></el-col>
			</el-row>
			<el-row>
				<el-col :span="13" :offset="2"><div>充电学习状态：</div></el-col>
			  	<el-col :span="4"><div><span v-if="this.g == 0">正常</span><span v-if="this.g == 1" style="color: red;">错误</span></div></el-col>
			</el-row>
			<el-row>
				<el-col :span="13" :offset="2"><div>放电学习状态：</div></el-col>
			  	<el-col :span="4"><div><span v-if="this.h == 0">正常</span><span v-if="this.h == 1" style="color: red;">错误</span></div></el-col>
			</el-row>
		</el-dialog>
		
		<el-dialog title="GPS" :visible.sync="Mapvisable" :before-close="Backchange">
			<div style="width: 100%;height: 500px;background: #009E94;">
				<div id="allmap" style="width: 100%;height: 500px"></div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {GetDevWheelChairlogslist} from '../api/api';
	
	export default {
		data(){
			return{
				token:"",
				maxHeight:600,
				Time:"",
				listloading:false,
				total:1,
				Curpage:1,
				Pagesize:20,
				inputMac:"",
				List:[],
				Findform:"",
				Bateryvisable:false,
				dianya:"",
				dianliu:"",
				dianliang:"",
				wendu:"",
				chongdian:"",
				battery:{
					d20:""
				},
				chuan:"",
            	jiexi:"",
            	a:"",
            	b:"",
            	c:"",
            	d:"",
            	e:"",
            	f:"",
            	g:"",
            	h:"",
            	Form:{
            		d2:""
            	},
            	Mapvisable:false,
            	timer:"",
            	outtime:"",
            	Betweenall:{},
            	Screenall:{},
            	statelist:[
            		{cn:"蓝牙连接"},
            		{cn:"锁定"},
            		// {cn:"训练"},
            		{cn:"推行"},
            		{cn:"设备充电"},
            	]
			}
		},
		beforeRouteLeave(to,from,next){
        	clearInterval(this.timer)
        	next()
        },
		methods:{
			Detail(index,row){
				this.Bateryvisable = true
				this.battery = Object.assign({}, row)
				var arr = this.battery.d20
				var arr2 = arr.substring(1,arr.length-1).split(",");
				this.dianya = parseFloat((parseInt(arr2[0],16) * 256 + parseInt(arr2[1],16)) * 0.1).toFixed(1)
				this.dianliu  = parseFloat((parseInt(arr2[2],16) * 256 + parseInt(arr2[3],16)) * 0.1).toFixed(1)
				this.dianliang = parseInt(arr2[4],16)
				this.wendu = parseInt(arr2[5],16) - 40
				this.chongdian = arr2[6]
				this.chuan = arr2[7]
				var str = parseInt(arr2[15],16)
				str & 1 ? this.a = 1 : this.a = 0
				str & 2 ? this.b = 1 : this.b = 0
				str & 4 ? this.c = 1 : this.c = 0
				str & 8 ? this.d = 1 : this.d = 0
				str & 16 ? this.e = 1 : this.e = 0
				str & 32 ? this.f = 1 : this.f = 0
				str & 64 ? this.g = 1 : this.g = 0
				str & 128 ? this.h = 1 : this.h = 0
			},
			handleCurrentChange(val){
				this.Curpage = val
				this.Find()
			},
			BeforeFind(){
				this.Curpage = 1
				this.Find()
			},
			Find(){
				if(this.Time){
					this.Betweenall = {"BETWEEN":{'time':[this.Time[0]/1000,this.Time[1]/1000]}}
				}else{
					this.Betweenall = {"BETWEEN":{}}
				}
				if(this.inputMac){
					this.Screenall = {"AND":{'did':'~' + this.inputMac}}
				}else{
					this.Screenall = {"AND":{}}
				}
				var ever = [this.Screenall,this.Betweenall]
				var ever2 = JSON.stringify(ever)
				if(this.Screenall || this.Betweenall){
					this.GetSportList(GetDevWheelChairlogslist,{page:this.Curpage,token:this.token,sort:"-time",q:ever2})
				}else{
					this.GetSportList(GetDevWheelChairlogslist,{page:this.Curpage,token:this.token,sort:"-time"})
				}
			},
			Inloop(){
				this.Find()
			},
			Loop(){
				this.timer = setInterval(() => {this.Inloop()},30000)
			},
			Refresh(){
				this.Time = ""
				this.inputMac = ""
				this.Curpage = 1
				this.GetSportList(GetDevWheelChairlogslist,{page:this.Curpage,token:this.token,sort:"-time"})
			},
//			显示地图
			showmap(index,row){
				this.Mapvisable = true
				this.Form = Object.assign({}, row);
				clearInterval(this.timer)
				this.outtime = setTimeout(() => {this.ready()},500)
			},
			Backchange(){
				clearTimeout(this.outtime);
				this.Loop()
				this.Mapvisable = false
			},
			d1Format(row,column){
				if(row[column.property]){
					let d1 = row[column.property]
					if(d1 == "1"){return "运动版"}
//					else if(d1 == "2"){return "医用版"}
//					else if(d1 == "3"){return "老年版"}
//					else if(d1 == "4"){return "智能版"}
				}else{
					return "无"
				}
			},
			d2Format(row,column){
				if(row[column.property]){
					let bb = row[column.property] + ""
					return "v" + bb.substring(0,1) + "." + bb.substring(1)
				}else{
					return "无"
				}
			},
			ready() {
				var a = this.Form.d2;
				a = (a.substring(1,a.length - 1)).split(",");
//				this.GPSchange(a)
		    	var map = new BMap.Map('allmap');
				var point = new BMap.Point(a[1], a[0]);
		    	map.centerAndZoom(new BMap.Point(a[1], a[0]), 13);
//		      	map.addControl(new BMap.MapTypeControl());
//		      	map.setCurrentCity('上海');
		      	map.enableScrollWheelZoom(true);
		      	map.enableDoubleClickZoom(true);
		      	var marker = new BMap.Marker(point);
		      	map.addOverlay(marker);
		      	marker.setAnimation(BMAP_ANIMATION_BOUNCE);
		   },
		   GetSportList(way,param){
		   		var that = this
		   		var list = []
		   		
		   		that.listloading = true
				way(param).then(res => {
					console.log(res)
					console.log("这是通用函数")
					list = res.data.items
//					that.List = res.data.items
					
					that.Pagesize = res.data.meta.perPage
					that.total = res.data.meta.totalCount
					for(var i=0;i<list.length;i++){
						var arr = []
						for(var j=7;j>2;j--){
							arr.push((list[i].d9 >> j & 1) == 0 ? "否":"是")
						}
						list[i].d9 = arr
					}
					that.List = list
					that.listloading = false
					
				}).catch(err => {
					console.log(err.response.data.message)
					that.$message.error(err.response.data.message)
					that.List = []
					that.listloading = false
				})
		   }
//			GPSchange(data){
//				var a = data
//				a = (a.substring(1,a.length - 1)).split(",");  
//				console.log("a[0]",a[0])
//				console.log("a[1]",a[1])
//			}
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.GetSportList(GetDevWheelChairlogslist,{page:this.Curpage,token:this.token,sort:"-time"})
			this.Loop()
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// WheelChairCycleLog.vue?82052062